import { Box, Stack, TextField, Typography, useTheme } from "@mui/material";
import { Row } from "react-bootstrap";
import { BoldRadar, BoldUserRemove } from "../../../../Icon";
import { EGIconButton } from "../../../../MainComponents/Button/IconButton/IconButton";
import { EGSpeedDial } from "../../../../MainComponents/Button/SpeedDial/SpeedDial";
import { EGSwitch } from "../../../../MainComponents/Switch/Switch";
import Comments from "../Comments";
import { useTranslation } from "react-i18next";
import { HelpIcon } from "../../../../MainComponents/HelpIcon/HelpIcon";

export const HostileEnvironment = ({
  actionsHostileEnv,
  switches,
  getOut,
  cancelIndicator,
  hdlSwitchIndicatorChange,
  textHostile,
  setTextHostile,
  reportDetail,
  editing,
  loading,
  saveIndicatorInfo,
}) => {
  const [t] = useTranslation("information");
  const theme = useTheme();

  return (
    <div className={`hostile ${getOut.hostile && "--getOut"}`}>
      <div
        className={`hostile__content rounded ${
          reportDetail?.hostile_place?.is_hostile_place_value &&
          !editing.hostile &&
          "confirmed"
        }`}
      >
        <div className="hostile__title">
          <Stack
            display="flex"
            direction="row"
            alignItems="center"
            justifyContent="start"
            spacing={1}
            width="80%"
            padding={switches.hostile && !editing.hostile ? 1.4 : 0}
            sx={{ overflow: "hidden" }}
          >
            <Box sx={{ height: 24, width: 24 }}>
              <BoldRadar
                color={
                  reportDetail?.hostile_place?.is_hostile_place_value &&
                  !editing.hostile
                    ? theme.palette.common.white
                    : theme.palette.purple.main
                }
              />
            </Box>

            <Box display="flex" alignItems="center">
              <div>
                <Typography
                  style={{ display: "inline" }}
                  color={
                    reportDetail?.hostile_place?.is_hostile_place_value &&
                    !editing.hostile
                      ? theme.palette.common.white
                      : theme.palette.blueGray700.main
                  }
                  component="p"
                  fontSize={16}
                  fontWeight={600}
                >
                  {reportDetail?.hostile_place?.is_hostile_place_value
                    ? t(
                        "information.hostile_environment_has_been_identified_report"
                      )
                    : t("information.did_report_create_hostile_environment")}
                </Typography>
                <div style={{ display: "inline" }}>
                  <HelpIcon
                    text={t("information.help_icon_hostile")}
                    className="mx-[5] d-inline-block"
                  />
                </div>
              </div>
            </Box>
          </Stack>

          {switches.hostile ? (
            editing.hostile ? (
              <Stack
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                flexDirection="row"
                flexWrap="nowrap"
                spacing={0.5}
              >
                <EGIconButton
                  disabled={loading.hostile}
                  iconName="check_icon"
                  color="success"
                  iconColor="white"
                  onClick={() => saveIndicatorInfo("hostile")}
                  title={t("information.save")}
                  placement="bottom"
                  sx={{ height: 24, width: 24, padding: 0 }}
                />
                <EGIconButton
                  disabled={loading.hostile}
                  iconName="close_icon"
                  color="error"
                  iconColor="white"
                  onClick={() => cancelIndicator("hostile")}
                  title={t("information.cancel")}
                  placement="bottom"
                  sx={{ height: 24, width: 24, padding: 0 }}
                />
              </Stack>
            ) : (
              <Stack
                position="absolute"
                top="50%"
                right={9}
                sx={{ transform: "translateY(-50%)" }}
              >
                <EGSpeedDial
                  actions={actionsHostileEnv}
                  tooltipPlacement="bottom"
                />
              </Stack>
            )
          ) : (
            <EGSwitch
              onChange={hdlSwitchIndicatorChange}
              checked={switches.hostile}
              id="hostile"
              size="small"
            />
          )}
        </div>

        {switches.hostile && (
          <div>
            {editing.hostile ? (
              <TextField
                id="outlined-multiline-static-detail-hostil-environment"
                label={`${t("information.details")}:`}
                value={textHostile}
                onChange={(e) => setTextHostile(e.target.value)}
                rows={4}
                fullWidth
                multiline
                sx={{ marginTop: 2 }}
              />
            ) : (
              <div>
                {reportDetail?.hostile_place?.comment && (
                  <div className="comment">
                    <Comments 
                      text={reportDetail?.hostile_place.comment} 
                      background="white"
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export const CompromisedAnonymity = ({
  actionsAnonymity,
  switches,
  getOut,
  cancelIndicator,
  hdlSwitchIndicatorChange,
  textCompromised,
  setTextCompromised,
  reportDetail,
  editing,
  loading,
  saveIndicatorInfo,
}) => {
  const [t] = useTranslation("information");
  const theme = useTheme();

  return (
    <div className={`anonymity ${getOut.compromised && "--getOut"}`}>
      <div
        className={`anonymity__content rounded ${
          reportDetail?.compromised_anonymity?.compromised_anonymity_value &&
          !editing.compromised &&
          "confirmed"
        } `}
      >
        <div className="anonymity__title">
          <Stack
            display="flex"
            direction="row"
            alignItems="center"
            justifyContent="start"
            spacing={1}
            width="80%"
            padding={switches.compromised && !editing.compromised ? 1.4 : 0}
            sx={{ overflow: "hidden" }}
          >
            <Box sx={{ height: 24, width: 24 }}>
              <BoldUserRemove
                color={
                  reportDetail?.compromised_anonymity
                    ?.compromised_anonymity_value && !editing.compromised
                    ? theme.palette.common.white
                    : theme.palette.teal.main
                }
              />
            </Box>

            <Box display="flex" alignItems="center">
              <div>
                <Typography
                  style={{ display: "inline" }}
                  color={
                    reportDetail?.compromised_anonymity
                      ?.compromised_anonymity_value && !editing.compromised
                      ? theme.palette.common.white
                      : theme.palette.blueGray700.main
                  }
                  component="p"
                  fontSize={16}
                  fontWeight={600}
                >
                  {reportDetail?.compromised_anonymity
                    ?.compromised_anonymity_value
                    ? t("information.anonymity_compromised")
                    : t("information.mark_as_anonymity_compromised")}
                </Typography>
                <div style={{ display: "inline" }}>
                  <HelpIcon
                    text={t("information.help_icon_compromised")}
                    className="mx-[5] d-inline-block"
                  />
                </div>
              </div>
            </Box>
          </Stack>
          {switches.compromised ? (
            editing.compromised ? (
              <Stack
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                flexDirection="row"
                flexWrap="nowrap"
                spacing={0.5}
              >
                <EGIconButton
                  disabled={loading.compromised}
                  iconName="check_icon"
                  color="success"
                  iconColor="white"
                  onClick={() => saveIndicatorInfo("compromised")}
                  title={t("information.save")}
                  placement="bottom"
                  sx={{ height: 24, width: 24, padding: 0 }}
                />
                <EGIconButton
                  disabled={loading.compromised}
                  iconName="close_icon"
                  color="error"
                  iconColor="white"
                  onClick={() => cancelIndicator("compromised")}
                  title={t("information.cancel")}
                  placement="bottom"
                  sx={{ height: 24, width: 24, padding: 0 }}
                />
              </Stack>
            ) : (
              <Stack
                position="absolute"
                top="50%"
                right={9}
                sx={{ transform: "translateY(-50%)" }}
              >
                <EGSpeedDial
                  actions={actionsAnonymity}
                  tooltipPlacement="bottom"
                />
              </Stack>
            )
          ) : (
            <EGSwitch
              onChange={hdlSwitchIndicatorChange}
              checked={switches.compromised}
              id="compromised"
              size="small"
            />
          )}
        </div>
        {switches.compromised && (
          <div>
            {editing.compromised ? (
              <TextField
                id="outlined-multiline-static-detail-anonymity-compromised"
                label={`${t("information.details")}:`}
                value={textCompromised}
                onChange={(e) => setTextCompromised(e.target.value)}
                rows={4}
                fullWidth
                multiline
                sx={{ marginTop: 2 }}
              />
            ) : (
              <div>
                {reportDetail?.compromised_anonymity?.comment && (
                  <div className="comment">
                    <Comments
                      text={reportDetail?.compromised_anonymity.comment}
                      background="white"
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export const AdditionalIndicators = ({
  actionsAnonymity,
  actionsHostileEnv,
  switches,
  getOut,
  cancelIndicator,
  hdlSwitchIndicatorChange,
  textCompromised,
  setTextCompromised,
  textHostile,
  setTextHostile,
  reportDetail,
  editing,
  loading,
  saveIndicatorInfo,
}) => {
  return (
    <Row className="rounded dyTheme1 dyBorder1 mt-20 px-[8] py-[20]">
      {/* Compromised anonymity  */}
      <CompromisedAnonymity
        actionsAnonymity={actionsAnonymity}
        switches={switches}
        getOut={getOut}
        cancelIndicator={cancelIndicator}
        hdlSwitchIndicatorChange={hdlSwitchIndicatorChange}
        textCompromised={textCompromised}
        setTextCompromised={setTextCompromised}
        reportDetail={reportDetail}
        editing={editing}
        loading={loading}
        saveIndicatorInfo={saveIndicatorInfo}
      />
      <span className="anonymity__divider" />
      {/* Hostile environment */}
      <HostileEnvironment
        actionsHostileEnv={actionsHostileEnv}
        switches={switches}
        getOut={getOut}
        cancelIndicator={cancelIndicator}
        hdlSwitchIndicatorChange={hdlSwitchIndicatorChange}
        textHostile={textHostile}
        setTextHostile={setTextHostile}
        reportDetail={reportDetail}
        editing={editing}
        loading={loading}
        saveIndicatorInfo={saveIndicatorInfo}
      />
    </Row>
  );
};
